import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { SimpleBanner } from './SimpleBanner';
import { removeBanner, selectBannerToDisplay } from './Banners.reducer';
import css from './BannerHost.scss';

const banners = {
  GenericAnnouncement: props => <SimpleBanner {...props} />,
  GenericNotification: props => <SimpleBanner {...props} />,
  SuccessNotification: props => <SimpleBanner {...props} type="success" />,
  FailureNotification: props => <SimpleBanner {...props} type="failure" />,
};

export const registerBanner = (componentName, component) => (banners[componentName] = component);

const mapStateToProps = (state, props) => ({
  activeBanner: selectBannerToDisplay(state, props.category),
});

const mapDispatchToProps = {
  onBannerClose: removeBanner,
};

export class BannerHostUnwrapped extends Component {
  handleBannerClose = () => {
    const {
      activeBanner: { id },
      onBannerClose,
    } = this.props;

    onBannerClose(id);
  };

  render() {
    const { category, activeBanner, className } = this.props;

    if (!activeBanner) {
      return null;
    }

    const { props: bannerProps, component: bannerType } = activeBanner;

    const BannerComponent = banners[bannerType];

    if (!BannerComponent) {
      throw new Error(`Unknown banner type '${bannerType}'`);
    }

    return (
      <div className={cx(css['banner-host'], css[`banner-host--${category}`], className)}>
        <BannerComponent {...bannerProps} onClose={this.handleBannerClose} />
      </div>
    );
  }
}

BannerHostUnwrapped.propTypes = {
  className: PropTypes.string,
  category: PropTypes.oneOf(['notification', 'announcement']).isRequired,
  onBannerClose: PropTypes.func.isRequired,
  activeBanner: PropTypes.shape({
    id: PropTypes.string.isRequired,
    props: PropTypes.object.isRequired,
    component: PropTypes.oneOf(Object.keys(banners)).isRequired,
  }),
};

export const BannerHost = connect(
  mapStateToProps,
  mapDispatchToProps
)(BannerHostUnwrapped);
